import React, { useState } from "react";
import { useBnbSelector } from "../../../../../redux/store";
import type { PriceType } from "../../../../../../../../common-deprecated/types/CommonTypes";
import Price from "../../price/Price";
import * as Styles from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/basket/BasketItems";
import * as Type from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { ToggleIconWrapper } from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { isRTL } from "../../../../../../../../common-deprecated/settings/utils/commonSettingUtils";

type BasketItemWrapperType = {
    sectionTitleLabel: string;
    itemCount: number;
    totalPrice: PriceType;
    children: React.ReactNode;
    trackExpand: () => void;
};

const BasketItemWrapper = (props: BasketItemWrapperType): JSX.Element => {
    const { sectionTitleLabel, itemCount, totalPrice, children, trackExpand } = props;
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const commonSettings = useBnbSelector((state) => state.commonSettings);

    return (
        <>
            <Styles.HeaderToggle
                isCollapsible
                onClick={() => {
                    if (!isOpen) trackExpand();
                    setIsOpen(!isOpen);
                }}
            >
                <Styles.HeaderToggleInner isOpen={isOpen}>
                    <ToggleIconWrapper isDown={!isOpen}>
                        <Icon variant="chevronUp" />
                    </ToggleIconWrapper>
                    <Styles.HeaderToggleTitle isRTL={isRTL(commonSettings)}>
                        <Type.SmallHeading>{sectionTitleLabel}</Type.SmallHeading>
                        <Styles.Counter>{itemCount}</Styles.Counter>
                    </Styles.HeaderToggleTitle>
                    <Price price={totalPrice} />
                </Styles.HeaderToggleInner>
            </Styles.HeaderToggle>
            {isOpen && <Styles.ContentWrapper>{children}</Styles.ContentWrapper>}
        </>
    );
};

export default BasketItemWrapper;
